import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=63fadc4e"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=63fadc4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports